export default [
  {
    path: "/groupbuy",
    component: () => import("../pages/groupBuy"),
    meta: {
      title: "拼团活动",
    },
  },
  {
    path: "/groupbuy/explain",
    component: () => import("../pages/groupBuy/explain"),
    meta: {
      title: "拼团说明",
    },
  },
  {
    path: "/groupbuy/share",
    component: () => import("../pages/groupBuy/share"),
    meta: {
      title: "销巴生活",
    },
  },
  {
    path: "/groupbuy/finish",
    component: () => import("../pages/groupBuy/finish"),
  },
];
